import * as cookie from 'cookie';
import { Location } from 'history';
import { bazaar_single_page_product_grid_url, logout_url } from 'mk/urls/functions';
import * as homeUrls from 'mk2/apps/home/urls';
import * as usersUrls from 'mk2/apps/users/urls';
import { parse } from 'query-string';
import * as uuid from 'uuid/v4';

export function getLastKnownUsernameCookie(): string {
    return cookie.parse(document.cookie)._remember || null;
}

export function storeLastKnownUsernameCookie(username: string) {
    document.cookie = cookie.serialize('_remember', username, {
        path: '/',
        maxAge: 400 * 24 * 60 * 60,  // 400 days
    });
}

export function getPregnancyNewsletterCookie(): boolean {
    return Boolean(cookie.parse(document.cookie).pregnancyNewsletterSubscribed);
}

export function storeNewsletterClosedCookie() {
    document.cookie = cookie.serialize('pregnancy_newsletter_closed', 'true', {
        path: '/',
        maxAge: 30 * 24 * 60 * 60,  // 30 days
    });
}

export function getPregnancyNewsletterClosedCookie(): boolean {
    return Boolean(cookie.parse(document.cookie).pregnancy_newsletter_closed);
}

function isUnsuitableRedirectUrl(url: string): boolean {
    return url.startsWith(logout_url())
        || url.indexOf(usersUrls.login) >= 0
        || url.indexOf('://') >= 0
        || url.indexOf(' ') >= 0;
}

export function gotoUrlAfterLoginOrSignup(baseUrl: string, location: Location, defaultUrl: string): string {
    let redirectTo = parse(location.search).next;
    redirectTo = (!redirectTo || isUnsuitableRedirectUrl(redirectTo))
        ? null
        : baseUrl + redirectTo; // FIXME az bude cela app v react, netreba absolut url a bude fungovat success toast

    if (!redirectTo) {
        redirectTo = baseUrl + defaultUrl;  // iframe can be embedded in other pages than www.modrykonik.sk, so we need to use absolute url
    }
    return redirectTo;
}
